import { VeltVideoPlayer} from '@veltdev/react';
import React from 'react'
import './VideoPlayerPage.css';

function VideoPlayerPage
() {
    return (
        <div id="VeltVideoPlayerContainer">
            <VeltVideoPlayer src={"https://firebasestorage.googleapis.com/v0/b/snippyly.appspot.com/o/external%2Fvelt.mp4?alt=media&token=d8af2697-c797-4610-b886-ca510b231097"} />
        </div>
    )
}

export default VideoPlayerPage;